import * as t from 'io-ts';
import { withFallback } from 'io-ts-types/lib/withFallback';
import { NotificationType, ScaleType } from '@/entities/auth/reminderConfiguration';

export const notificationSetting = t.type({
  type: t.keyof({
    [NotificationType.inspection_available]: null,
    [NotificationType.checklist_reminder]: null,
    [NotificationType.inspection_overdue_for_supervisors]: null,
    [NotificationType.issue_available]: null,
    [NotificationType.issue_reminder]: null,
    [NotificationType.approval_status_change]: null,
    [NotificationType.approval_pending]: null,
    [NotificationType.issue_approval_pending]: null,
    [NotificationType.issue_approval_status_change]: null,
  }),
  push: t.boolean,
  email: t.boolean,
  sms: t.boolean,
});

export const notificationSettings = t.type({
  id: t.number,
  data: notificationSetting,
});

export const data = t.type({
  notificationEmail: withFallback(t.string, ''),
  phoneNumber: withFallback(t.string, ''),
  notificationSettings: t.array(notificationSettings),
});

export const configuration = t.type({
  id: t.number,
  data,
});

const timeSetting = t.type({
  from: t.number,
  to: t.union([t.number, t.null]),
  value: t.union([t.number, t.null]),
  scale: t.union([
    t.literal(ScaleType.minute),
    t.literal(ScaleType.hour),
    t.literal(ScaleType.day),
    t.literal(ScaleType.week),
  ]),
});

const timeWindowSetting = t.type({
  id: t.number,
  data: timeSetting,
});

export const timeWindow = t.type({
  data: t.array(timeWindowSetting),
});
